<nav class="app__subnav">
    <a
        routerLink="/financial/targets"
        routerLinkActive="app__subnav__active">
        Targets
    </a>
    <a
        routerLink="/financial/overhead"
        routerLinkActive="app__subnav__active">
        Overhead
    </a>
    <a
        routerLink="/financial/employees"
        routerLinkActive="app__subnav__active">
        Employees
    </a>
    <a
        routerLink="/financial/projects"
        routerLinkActive="app__subnav__active">
        Projects
    </a>
    <a
        routerLink="/financial/research-development"
        routerLinkActive="app__subnav__active">
        O&amp;O
    </a>
    <a
        routerLink="/financial/jira-projects"
        routerLinkActive="app__subnav__active">
        Jira
    </a>
    <a
        routerLink="/financial/turnover"
        routerLinkActive="app__subnav__active">
        Turnover
    </a>
        <a
            routerLink="/financial/budgets"
            routerLinkActive="app__subnav__active">
            Budgets
        </a>
        <a
            routerLink="/financial/contracts"
            routerLinkActive="app__subnav__active">
            Contracts
        </a>
        <a
            routerLink="/financial/project-budgets"
            routerLinkActive="app__subnav__active">
            Project budgets by account
        </a>
</nav>
